// extracted by mini-css-extract-plugin
module.exports = {"metricCard":"MetricCard_metricCard__Hlcdd","data":"MetricCard_data__2kIBo","value":"MetricCard_value__NrLJN"};